import { $t } from "../../../utils/intl";
import { handleTextField } from "../../prefill/helpers";
import type { FieldRegistryConfig } from "../../types";
import { fieldsText } from "../fields.text";
import { defaultToReviewString } from "../review/reviewString.helpers";
import { TextAreaFieldControl } from "./TextareaFieldControl/TextAreaFieldControl";

export type TextareaFieldValue = string;

export const textareaFieldConfig: FieldRegistryConfig<TextareaFieldValue> = {
  icon: "textarea",
  control: (props) => (
    <TextAreaFieldControl placeholder={$t(fieldsText.textPlaceholder)} {...props} />
  ),
  prefill: handleTextField,
  toReviewString: defaultToReviewString,
};
